import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme)=>({
    templateName:{
        fontWeight:"bold",
        fontSize:"1rem",
    },
    templateItem:{
        fontWeight:"bold",
        fontSize:"0.75rem",
        color:theme.typography.color.tertiary
    },
    itemList:{
        fontWeight:"bold",
        fontSize:"0.75rem",
        color:theme.typography.color.tertiary,
        textTransform:"uppercase",
        margin:12
    },
    list:{
        overflow:"auto",
        height:"320px"
    },
    avatar:{
        background:"transparent"
    },
    inspectionName:{
        color:theme.typography.color.secondary,
        fontSize:"0.875rem",
        fontWeight:"bold",
        marginInlineStart:"12px !important"
    },
    inspectionQty:{
        color:theme.typography.color.tertiary,
        fontSize:"0.75rem",
        fontWeight:"bold"
    },
    editbtn:{
        width:"100%",
        '&:hover':{
            background:"transparent"
        }
    }
}))